import React from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import { above } from "core-web/utils/mediaqueries";
import Link from "core-web/components/Link";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    background-color: ${colors.lightGrey};
    border: 1px solid ${colors.grey};
    border-top-left-radius: 1px;
    border-top-right-radius: 1px;
    border-width: 1px 0 0;
    pointer-events: all;
    padding: 16px;
    width: 100%;

    ${above.tabletSm} {
        border-radius: 4px;
        border-width: 1px;
        margin: 16px;
        width: 520px;
    }

    display: var(--display-cookie-consent);

    &.hide-cookie-consent {
        display: none;
    }
`;

const Content = styled("div")`
    font-size: 14px;
    line-height: 24px;
`;

const CookieLink = styled(Link)`
    text-decoration: underline;
    color: inherit;

    &:hover {
        text-decoration: none;
    }
`;

const StyledRoundedButton = styled("button")`
    font: 600 14px/1em "Akkurat";
    letter-spacing: 0.02em;
    height: 38px;
    padding: 12px;
    border-radius: 54px;
    color: ${colors.white};
    text-transform: uppercase;
    background-color: ${colors.darkGrey};
    &:hover {
        background-color: ${colors.hoverDarkGrey};
    }
`;

const CookiesComponent = ({ isCookiesAccepted, onAcceptCookies }) => {
    const cookieDisclaimer = useSelector(({ application }) => application.config?.options?.cookies?.disclaimer) || {};
    const { text, lifespan, button: buttonText, link: linkObject } = cookieDisclaimer;
    const { url: link, text: linkText } = linkObject || {};

    const handleClick = () => {
        Cookies.set("cookies_accepted", true, { expires: lifespan ? Number(lifespan) : 30 });
        onAcceptCookies();
    };

    if (!text || !link || !linkText) {
        return null;
    }

    return (
        <Wrapper className={isCookiesAccepted ? "hide-cookie-consent" : ""}>
            <Content mb="16px">
                {text.trim()}&nbsp;
                <CookieLink to={link}>{linkText}</CookieLink>
            </Content>

            <Content display="flex" justifyContent={["normal", "flex-end"]}>
                <StyledRoundedButton theme="black" onClick={handleClick}>
                    {buttonText}
                </StyledRoundedButton>
            </Content>
        </Wrapper>
    );
};

CookiesComponent.propTypes = {
    isCookiesAccepted: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onAcceptCookies: PropTypes.func,
};

CookiesComponent.defaultProps = {
    isCookiesAccepted: false,
    onAcceptCookies: null,
};

export default CookiesComponent;
